import { getDefaultExportFromCjs } from "./_commonjsHelpers.js";
import { __require as requireSrc } from "../node_modules/.pnpm/postcss-discard-duplicates@5.1.0_postcss@8.5.8/node_modules/postcss-discard-duplicates/src/index.js";
var srcExports = requireSrc();
const postcssDuplicates = /* @__PURE__ */ getDefaultExportFromCjs(srcExports);
export {
  postcssDuplicates as default
};
//# sourceMappingURL=index.js.map
